import { render } from "./Announcements.vue?vue&type=template&id=334dbdea&scoped=true"
import script from "./Announcements.vue?vue&type=script&lang=js"
export * from "./Announcements.vue?vue&type=script&lang=js"

import "./Announcements.vue?vue&type=style&index=0&id=334dbdea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-334dbdea"]])

export default __exports__